var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScratchCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5498_29",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5498_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2827 12.3463L14.3845 11.077L16.4865 12.3463L15.925 9.948L17.7807 8.348L15.348 8.14225L14.3845 5.88475L13.4212 8.14225L10.9885 8.348L12.8442 9.948L12.2827 12.3463ZM14.777 18.7307H18.3192C18.2602 19.0679 18.1196 19.3458 17.8972 19.5645C17.6747 19.783 17.3897 19.9192 17.0422 19.973L5.9405 21.346C5.44166 21.4167 4.99391 21.2987 4.59725 20.9923C4.20041 20.6859 3.97183 20.2833 3.9115 19.7845L2.63475 9.4655C2.57441 8.96667 2.6965 8.51825 3.001 8.12025C3.3055 7.72208 3.70708 7.49608 4.20575 7.44225L5.26925 7.33075V8.83075L4.40775 8.927C4.31791 8.93333 4.24741 8.97017 4.19625 9.0375C4.14491 9.10483 4.12566 9.18333 4.1385 9.273L5.4115 19.5923C5.42433 19.6821 5.46283 19.7526 5.527 19.8038C5.591 19.8551 5.66791 19.8743 5.75775 19.8615L14.777 18.7307ZM9.077 16.7308C8.57183 16.7308 8.14425 16.5557 7.79425 16.2057C7.44425 15.8557 7.26925 15.4282 7.26925 14.923V4.30775C7.26925 3.80258 7.44425 3.375 7.79425 3.025C8.14425 2.675 8.57183 2.5 9.077 2.5H19.6922C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80258 21.5 4.30775V14.923C21.5 15.4282 21.325 15.8557 20.975 16.2057C20.625 16.5557 20.1974 16.7308 19.6922 16.7308H9.077ZM9.077 15.2308H19.6922C19.7821 15.2308 19.8558 15.2019 19.9135 15.1442C19.9712 15.0866 20 15.0128 20 14.923V4.30775C20 4.21792 19.9712 4.14417 19.9135 4.0865C19.8558 4.02883 19.7821 4 19.6922 4H9.077C8.98716 4 8.91342 4.02883 8.85575 4.0865C8.79808 4.14417 8.76925 4.21792 8.76925 4.30775V14.923C8.76925 15.0128 8.79808 15.0866 8.85575 15.1442C8.91342 15.2019 8.98716 15.2308 9.077 15.2308Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratchCard);
export default __webpack_public_path__ + "static/media/scratch-card.968cdd63e71d670b1597f5e67a0b845b.svg";
export { ForwardRef as ReactComponent };